import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { BillStatistics, ContractStatType } from "src/app/shared/types/statistics-types";

@Injectable({
  providedIn: "root",
})
export class StatisticsService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  getContractStatistics(instanceStatus: string): Observable<ContractStatType[]> {
    return this.http.get<ContractStatType[]>(
      `${this.apiUrl}/api/statistics/contracts?instanceStatus=${instanceStatus}`,
    );
  }

  getBillStatistics(year: number): Observable<BillStatistics> {
    return this.http.get<BillStatistics>(
      `${this.apiUrl}/api/statistics/bills?year=${year}`,
    );
  }
}
